import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getFiles } from '@/store/files/actions';

import { selectFiles } from '@/store/files/selectors';

import { Resources } from '@shared/resources';
import { getDefaultMaterialImage } from '@shared/utils/topic-utils';

import PropTypes from 'prop-types';

import GroupsPlaceholder from '@/assets/images/GroupPlaceholder.png';
import AvatarPlaceholder from '@/assets/images/PortraitPlaceholder.png';

export default function useImage(uuid, type, placeholderId) {
  const { files, isLoadingUuid } = useSelector(selectFiles);

  const dispatch = useDispatch();

  useEffect(() => {
    if (uuid && !files[uuid] && !isLoadingUuid.includes(uuid)) {
      dispatch(getFiles(uuid));
    }
  }, [uuid]);

  const typeImage = () => {
    switch (type) {
      case 'avatar':
        return AvatarPlaceholder;

      case 'groups':
        return GroupsPlaceholder;

      case 'topic':
      case 'planning':
        return getDefaultMaterialImage(placeholderId);

      case 'compilation':
      case 'track':
        return Resources.Images.Empty;

      case 'badge':
        return Resources.Images.Badge;

      default:
        return null;
    }
  };

  return useMemo(() => {
    if (!uuid || !files[uuid]) {
      return typeImage();
    } else {
      return files[uuid];
    }
  }, [files[uuid], uuid]);
}

useImage.propTypes = {
  uuid: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  placeholderId: PropTypes.any, // Используется для перекида id для обложек (иногда это нужно, например для топиков)
};
